import type { DailyDestination } from '../api/journal';

/** A daily's content destination → a client URL. `open` rides the land screen's own `?open=`
 *  deep link (LandScreen.tsx), which routes every activity type through `hotspotAction`, so a new
 *  daily needs no client change. Unknown shapes fall back to the Journal. */
export function dailyHref(d: DailyDestination | null | undefined): string {
  if (d?.screen === 'habitat') return '/habitat';
  if (d?.land) return `/world/lands/${d.land}${d.open ? `?open=${encodeURIComponent(d.open)}` : ''}`;
  return '/journal';
}
